import React from 'react'

const Databes = () => {
  return (
    <div className='skills__content'>
    <h3 className='skills__title'>Database</h3>

    <div className='skill__box'>
        <div className='skills__group'>
            <div className='skills__data'>
            <i class='bx bxs-data' ></i>                            
            <div>
                    <h3 className='skills__name'>MySQl</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bxs-data' ></i>                
                <div>
                    <h3 className='skills__name'>Microsoft SQL Server</h3>
                    <span className='skills__level'> </span>
                </div>
            </div>
            
            <div className='skills__data'>
            <i class='bx bxs-data' ></i>                
            <div>
                    <h3 className='skills__name'>MongoDB</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bxs-data' ></i>                
                <div>
                    <h3 className='skills__name'>PostgreSQL</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
        </div>
       
        
    </div>
</div>
  )
}

export default Databes